import ReactDOM from "react-dom";
import "antd/dist/antd.compact.css";
import ConfigProvider from "antd/lib/config-provider";
import { BrowserRouter } from "react-router-dom";
import localeRu from "antd/es/locale/ru_RU";
import { RecoilRoot } from "recoil";
import React from "react";
import reportWebVitals from "./reportWebVitals";
import { App } from "./components";

ReactDOM.render(
  <React.StrictMode>
    <RecoilRoot>
      <ConfigProvider locale={localeRu}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </ConfigProvider>
    </RecoilRoot>
  </React.StrictMode>,
  document.getElementById("root")
);

reportWebVitals();
